$( () => {
    // Initialize every "stories" section on the page
    document.querySelectorAll('.section-stories').forEach(initializeStorySection);

    function initializeStorySection(section) {
        // Cache DOM references
        const videos   = Array.from(section.querySelectorAll('video'));
        const playBtns = Array.from(section.querySelectorAll('.playStories'));
        const muteBtns = Array.from(section.querySelectorAll('.muteToggle'));
        
      
        let activeIndex = 0;
        let userPaused  = false;
      
        // 1️⃣ Reset all videos to paused + update buttons
        function resetAll() {
            videos.forEach((v, i) => {
            v.pause();
            if (playBtns[i]) {
            playBtns[i].innerHTML = '<i class="fas fa-play"></i>';
                }
            });
        }
      
        // 2️⃣ Play one video (and pause the rest)
        function playOne(idx) {
          resetAll();
          activeIndex = idx;
          videos[idx].play();
          playBtns[idx].innerHTML = '<i class="fas fa-pause"></i>';
        }
      
        // 3️⃣ Toggle a single video
        function togglePlay(idx) {
          const vid = videos[idx];
          const btn = playBtns[idx];
      
          if (vid.paused) {
            userPaused = false;
            playOne(idx);
          } else {
            userPaused = true;
            vid.pause();
            btn.innerHTML = '<i class="fas fa-play"></i>';
          }
        }
      
        // 4️⃣ Bind play buttons
        playBtns.forEach((btn, idx) => {
          btn.addEventListener('click', () => togglePlay(idx));
        });
      
        // 5️⃣ Global mute toggle for this section
        function toggleMute() {
          // decide based on first video’s current muted state
          const shouldUnmute = videos[0].muted;
          videos.forEach(v => v.muted = !shouldUnmute);
          muteBtns.forEach(btn => {
            const icon = btn.querySelector('i');
            if (!icon) return;
            icon.classList.toggle('fa-volume-up', shouldUnmute);
            icon.classList.toggle('fa-volume-mute', !shouldUnmute);
          });
        }
        muteBtns.forEach(btn => btn.addEventListener('click', toggleMute));
      
        // 6️⃣ When a video ends, advance to next
        videos.forEach((vid, idx) => {
          vid.addEventListener('ended', () => {
            playBtns[idx].innerHTML = '<i class="fas fa-play"></i>';
            if (idx + 1 < videos.length) {
              playOne(idx + 1);
            }
          });
        });
      
        // 7️⃣ Pause/resume on scroll via IntersectionObserver
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target !== section) return;
      
            if (entry.isIntersecting) {
              // resume only if not user‑paused
              const vid = videos[activeIndex];
              if (vid.paused && !userPaused) {
                vid.play();
                playBtns[activeIndex].innerHTML = '<i class="fas fa-pause"></i>';
              }
            } else {
              // pause all when scrolled out
              videos.forEach((v, i) => {
                if (!v.paused) {
                  v.pause();
                  playBtns[i].innerHTML = '<i class="fas fa-play"></i>';
                }
              });
            }
          });
        }, { threshold: 0.5 });
        observer.observe(section);
      
        // 8️⃣ Kick off by autoplaying the first video once the page loads
        window.addEventListener('load', () => {
          setTimeout(() => playOne(0), 100);
        });
      }
  
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/stories.js